import type {ReactNode, TouchEventHandler} from 'react';
import React, {useState} from 'react';
import styles from './swiper.module.scss';

interface SwiperProps {
  onSwipeRight: VoidFunction;
  onSwipeLeft: VoidFunction;
  swipeThreshold?: SwipeSensitivity;
  children: ReactNode;
  containerClasses?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

enum SwipeSensitivity {
  LOW = 100,
  MEDIUM = 50,
  HIGH = 25,
}

export function Swiper({onSwipeRight, onSwipeLeft, swipeThreshold = SwipeSensitivity.MEDIUM, children, containerClasses = '', onClick}: SwiperProps) {
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  const onTouchStart: TouchEventHandler<HTMLDivElement> = (e) => {
    setTouchEnd(0);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove: TouchEventHandler<HTMLDivElement> = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd: TouchEventHandler<HTMLDivElement> = () => {
    if (!touchStart || !touchEnd) return;

    const minSwipeDistance = swipeThreshold;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      onSwipeLeft();
    } else if (isRightSwipe) {
      onSwipeRight();
    }
  };

  return (
    <div onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onTouchMove={onTouchMove} className={containerClasses} onClick={onClick}>
      {children}
    </div>
  );
}
